export default __webpack_public_path__ + "es-extra.b80575cdf988e1a7e3a915abe97f63b4.json";